import { get } from "../api";

// Interface pour les statistiques du proprietaire
export interface DashboardStats {
    totalBiens: number;
    contratsActifs: number;
    revenusTotal: number;
    locataires: number;
}

/**
 * Récupère les statistiques du dashboard proprietaire
 * @returns Promesse contenant les statistiques
 */
export const getProprietaireStats = async (): Promise<DashboardStats> => {
    try {
        const response = await get("/v1/dashboard/proprietaire/stats");
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error fetching proprietaire stats:", error);
        // Retourner des valeurs par défaut en cas d'erreur
        return {
            totalBiens: 0,
            contratsActifs: 0,
            revenusTotal: 0,
            locataires: 0
        };
    }
};

/**
 * Récupère les statistiques du dashboard locataire
 * @returns Promesse contenant les statistiques du locataire
 */
export const getLocataireStats = async () => {
    try {
        const response = await get("/v1/dashboard/locataire/stats");
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error fetching locataire stats:", error);
        return null;
    }
};

/**
 * Récupère les statistiques du dashboard admin
 * @returns Promesse contenant les statistiques admin
 */
export const getAdminStats = async () => {
    try {
        const response = await get("/v1/dashboard/admin/stats");
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error fetching admin stats:", error);
        return null;
    }
};
